import React, { useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { colors, shadows } from '../tokens'

const useStyles = makeStyles({
  anchor: {
    position: 'relative',
  },
  panel: {
    position: 'absolute',
    top: 44,
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
    border: `1px solid ${colors.border}`,
    borderRadius: '12px',
    boxShadow: shadows.popup,
  },
})

/**
 * Wraps a trigger and an absolutely positioned panel that closes on an
 * outside click or Escape.
 */
const PopoverPanel = ({
  open,
  onClose,
  trigger,
  children,
  width = 260,
  align = 'left',
  panelStyle,
}) => {
  const classes = useStyles()
  const rootRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined

    const handleMouseDown = event => {
      if (rootRef.current && !rootRef.current.contains(event.target)) onClose()
    }
    const handleKeyDown = event => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  return (
    <div className={classes.anchor} ref={rootRef}>
      {trigger}
      {open && (
        <div
          className={classes.panel}
          style={{ width, [align]: 0, ...panelStyle }}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default PopoverPanel
